//BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023

import { memo } from 'react';
import { BzHeading, BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';


const TabNewsContent = ({ handleNewsOverview, arrNewsScrips, handleOnClickScrip, scripDetails, removeScrips, addScrips, onBuySellClick, handleOverview, nActiveCard, strSearchActiveTab, ...props }) => {


    return (
        <>
            {/* Bhagyashri P [04-12-2023] : BT-96728 Global Search Feature - class changes Starts  */}
            <Container fluid className='px-3 p-0'>
                <div className='pb-3'>
                    {arrNewsScrips?.length > 0 && arrNewsScrips?.map((each, i) => (
                        <BzCard key={i} className='p-0 my-3 bdr-btm global-search-focus' style={{ border: nActiveCard === i ? 'solid 1px' : null }} tabindex={nActiveCard === i ? 0 : -1} id={'globalsearchCard' + strSearchActiveTab + i} >
                            <Row className='g-0' >
                                <Col md={9} className='d-flex justify-content-start align-self-center chips-wrap'>
                                    <BzHeading className='font-medium cursor-pointer font-size3 color-text me-3'>{each?.news_content}</BzHeading>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end align-self-center'>
                                    <div className='icon-16 icon-forward-arrow icon-dark' onClick={(e) => { e.stopPropagation(); handleNewsOverview(each); }} ></div>
                                </Col>
                            </Row>

                            <Row className='g-0 mb-3'>
                                <Col className='justify-content-start align-self-center'>
                                    <div className='mt-1'>
                                        <Row className='g-0'>
                                            <Col className='d-flex align-items-center'>
                                                <div className='chips-wrap float-start'>
                                                    {/* <BzChip className={`ms-2 chips  align-self-center`}>{each?.eventType}</BzChip> */}
                                                    <div className='font-regular font-size1 cursor-pointer color-subtext'>{each?.date_time}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </BzCard>
                    ))}
                </div>
            </Container>
            {/* Bhagyashri P [04-12-2023] : BT-96728 Global Search Feature - class changes Ends  */}

        </>
    );
};

export default memo(TabNewsContent);

//BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023


